import React, { createContext, useContext } from 'react';
import { usePageScrollTracker } from './usePageScrollTracker';

const ScrollTrackerContext = createContext({ register: () => {}, passed: {} });

export function ScrollTrackerProvider({ children }) {
  const tracker = usePageScrollTracker();
  return (
    <ScrollTrackerContext.Provider value={tracker}>
      {children}
    </ScrollTrackerContext.Provider>
  );
}

export function useScrollTracker() {
  return useContext(ScrollTrackerContext);
}
